import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WithContext as ReactTags } from 'react-tag-input';

import Styles from './styles';

const RemoveTag = ({ onClick, className }) => (
  <FontAwesomeIcon icon="times" onClick={onClick} className={className} onKeyDown={onClick} />
);
RemoveTag.propTypes = {
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

const KEY_CODES = {
  COMMA: 188,
  ENTER: 13
};

const delimiters = [KEY_CODES.COMMA, KEY_CODES.ENTER];

const TagInput = props => (
  <Styles.ReactTagsBootstraped>
    <ReactTags {...props} autofocus={false} delimiters={delimiters} removeComponent={RemoveTag} />
  </Styles.ReactTagsBootstraped>
);
TagInput.propTypes = {
  tags: PropTypes.array.isRequired,
  suggestions: PropTypes.array.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleAddition: PropTypes.func.isRequired
};
export default TagInput;
